import { Modal, Button, ButtonsGroup } from "@crunchyroll/cx-web-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const AccountRestrictedModal = ({
  isOpen,
  title,
  description,
  handleClose,
  confirmBtn,
}) => (
  <Modal className="reset" isOpen={isOpen} handleClose={handleClose}>
    <Modal.Content>
      <Modal.Body>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Text>{description}</Modal.Text>
      </Modal.Body>
      <Modal.ButtonsGroup>
        <ButtonsGroup>
          {confirmBtn}
          <Button type="one-weak" onClick={handleClose}>
            <FormattedMessage id="account_restricted.modal.close" />
          </Button>
        </ButtonsGroup>
      </Modal.ButtonsGroup>
    </Modal.Content>
  </Modal>
);

AccountRestrictedModal.propTypes = {
  confirmBtn: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
};

export default AccountRestrictedModal;
